import { useFormContext, Controller } from 'react-hook-form';
import _ from 'lodash';
import { useState, useEffect } from 'react';
import MaterialIconToolTip from '../MaterialIconToolTip';

const MultipleDomains = ({
    id,
    label,
    name,
    required,
    placeholder,
    className = '',
    shouldUnregister,
    style = {},
    labelClassName = '',
    iconRight,
    isLoading,
    renderInfo
}) => {
    const [inputValue, setInputValue] = useState('');

    const {
        formState: { errors },
        control,
    } = useFormContext();

    const error = _.get(errors, name) ? _.get(errors, name).message : '';
    const validateDomain = (domain) => {
        const domainRegex = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/;
        const urlRegex = /^(https?:\/\/)((?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9])(?:\/.*)?$/;
        const domainToCheck = String(domain).toLowerCase();
        return domainRegex.test(domainToCheck) || urlRegex.test(domainToCheck);
    };

    return (
        <div
            className={`block px-2 ${className}`}
            style={{
                minHeight: 0,
                minWidth: 0,
                ...style,
            }}
        >
            {label && (
                <label htmlFor={id} className={`text-scogo99 font-normal text-font09 md:text-font11 labelFotnSize ${labelClassName}`}>
                    {label} {required && <span className='text-scogoorange'>*</span>}
                    {renderInfo ? renderInfo : <></>}
                </label>
            )}
            <div className={iconRight || isLoading ? 'relative' : ''}>
                <Controller
                    key={name}
                    control={control}
                    name={name}
                    rules={{ required: { value: required, message: 'Required' } }}
                    shouldUnregister={shouldUnregister}
                    render={({ field: { onChange, onBlur, value = [], name, ref } }) => {

                        const handleKeyDown = (e) => {
                            if (e.key === 'Enter' || e.key === ',') {
                                e.preventDefault();
                                if (inputValue.trim() && validateDomain(inputValue.trim())) {
                                    if (!value.includes(inputValue.trim())) {
                                        const newValue = [...value, inputValue.trim()];
                                        onChange(newValue);
                                    }
                                    setInputValue('');
                                }
                            }
                        };

                        const handleChange = (e) => {
                            const newValue = e.target.value;
                            setInputValue(newValue);

                            // Check if the input ends with a space, comma, or tab
                            if (newValue.endsWith(' ') || newValue.endsWith(',') || newValue.endsWith('\t')) {
                                const trimmedValue = newValue.trim().replace(/,$/, '');
                                if (trimmedValue && validateDomain(trimmedValue)) {
                                    if (!value.includes(trimmedValue)) {
                                        onChange([...value, trimmedValue]);
                                    }
                                    setInputValue('');
                                }
                            }
                        };

                        const handleBlur = (e) => {
                            const trimmedValue = inputValue.trim();
                            if (trimmedValue && validateDomain(trimmedValue)) {
                                if (!value.includes(trimmedValue)) {
                                    onChange([...value, trimmedValue]);
                                }
                                setInputValue('');
                            }
                            onBlur(e);
                        };

                        const removeEmail = (index) => {
                            const newValue = [...value];
                            newValue.splice(index, 1);
                            onChange(newValue);
                        };

                        return (
                            <div
                                className={`font-normal text-font09 md:text-font11 block w-full focus:ring-0 px-0 border-b-2 border-t-0 border-r-0 border-l-0 ${_.get(errors, name) ? 'border-scogoclosed focus:border-scogoclosed' : 'border-scogoddd focus:border-scogoprimary inputFontSize'}`}
                                style={{
                                    minHeight: '3rem',
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    alignItems: 'center',
                                    gap: '4px'
                                }}
                            >
                                {value && value.length > 0 && value.map((email, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            background: 'rgba(244, 138, 33, 0.1)',
                                            color: '#F48A21',
                                            fontSize: '0.875rem',
                                            padding: '2px 8px',
                                            borderRadius: '4px',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            margin: '2px'
                                        }}
                                    >
                                        {email}
                                        <span
                                            onClick={() => removeEmail(index)}
                                            style={{
                                                marginLeft: '6px',
                                                cursor: 'pointer',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            ×
                                        </span>
                                    </div>
                                ))}
                                <input
                                    id={id}
                                    type="text"
                                    value={inputValue}
                                    onChange={handleChange}
                                    onKeyDown={handleKeyDown}
                                    onBlur={handleBlur}
                                    placeholder={placeholder || "Type domain and press Enter"}
                                    style={{
                                        border: 'none',
                                        outline: 'none',
                                        flex: '1',
                                        minWidth: '120px',
                                        background: 'transparent',
                                        height: '3rem'
                                    }}
                                    ref={ref}
                                />
                                {iconRight && (
                                    <MaterialIconToolTip
                                        materialIconClass={`material-icons-outlined text-font16 absolute right-2 top-2 text-scogoprimary hover:text-scogoorange cursor-pointer max-w-max`}
                                        title={iconRight.hoverTitle}
                                        materialIconName={iconRight.name}
                                        onClick={iconRight.onClick}
                                    />
                                )}
                            </div>
                        );
                    }}
                />
                <div className='flex mb-1'>
                    {error && <span className='text-scogoclosed text-font08 font-normal inputFontSize h-6 w-[100%]'>{error}</span>}
                </div>
            </div>
        </div>
    );
};

export default MultipleDomains;
